<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="dataset.data.status == 0 && dataset.data.enable_contradictory == 2" type="button"
                            elevation="0" color="primary" @click="updateContradictory"
                            :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/revisao-credito">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data.status != 0 || dataset.data.enable_contradictory != 2">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>
                    Prazo para enviar contraditórios está encerrado!
                </v-banner>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm" v-if="dataset.data && dataset.data.user">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes credor</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled id="name" label="Nome completo"
                                                v-model="dataset.data.user.name" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="E-mail"
                                                v-model="dataset.data.user.email" required outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Contraditório</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Descrição</p>
                                        <tiptap-vuetify
                                            :disabled="dataset.data.status !== 0 || dataset.data.enable_contradictory != 2"
                                            v-model="dataset.data.contradictory_reason" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto" />
                                    </v-col>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Documento</p>
                                        <v-file-input
                                            :disabled="dataset.data.status !== 0 || dataset.data.enable_contradictory != 2"
                                            :show-size="true" counter hint="O arquivo não pode ser superior a 15MB"
                                            dense prepend-icon="" outlined placeholder="Selecionar documento"
                                            :clearable="true" hide-details="auto" label="Adicionar documento"
                                            @change="onFileSelected($event)">
                                        </v-file-input>
                                        <template>
                                            <v-row class="mt-n3" v-if="dataset.data.contradictory_reason_file_url">
                                                <v-col cols="12">
                                                    <v-btn type="button" elevation="0" color="primary" outlined
                                                        :href="dataset.data.contradictory_reason_file_url"
                                                        target="_blank">Visualizar
                                                        documento
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data.userEvent && dataset.data.userEvent.length">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Habilitação / Divergência</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        
                                        <strong>Devedora: </strong> <span>{{ dataset.data.userEvent[0].client ?
                                            dataset.data.userEvent[0].client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.userEvent[0].created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                            }}</span>
                                        <br />
                                        <br>
                                        <span><strong>NEGÓCIO(S)</strong></span>
                                        <br />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-expansion-panels>
                                            <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.userEvent[0].items"
                                                :key="eventIndex">
                                                <v-expansion-panel-header>
                                                    <div  class="d-flex align-center">
                                                        <strong>Origem: </strong>
                                                        <span>
                                                            {{
                                                                truncateText(
                                                                    eventItem.origin,
                                                                    30
                                                                )
                                                            }}
                                                        </span>
                                                         / 
                                                        <strong>Valor: </strong>
                                                        <span v-if="eventItem.amount">
                                                            {{
                                                                eventItem.currency | enum(
                                                                    dataset.currencyTypes,
                                                                    'id',
                                                                    'currencyFormat'
                                                                )
                                                            }}
                                                            {{ eventItem.amount | currency }}
                                                        </span>
                                                        <span v-else>N/A</span>

                                                        <v-spacer></v-spacer>

                                                        <v-chip label class="mr-10" small
                                                            :color="getColorByStatus(eventItem.status)"
                                                            style="color: white">
                                                            {{ eventItem.status | enum(dataset.eventStatus, 'id',
                                                                'name') }}
                                                        </v-chip>
                                                    </div>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row>
                                                        <v-col>
                                                            <p>
                                                                <span class="section-info-title">Devedora</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ dataset.data.client.name }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Origem</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.origin }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Moeda</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{
                                                                        eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'name'
                                                                        )
                                                                    }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Valor</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">{{
                                                                    eventItem.currency
                                                                    | enum(
                                                                        dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat'
                                                                    )
                                                                    }}
                                                                    {{
                                                                        eventItem.amount | currency
                                                                    }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Número pedido</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.request_number }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Motivo</span>
                                                                <br/>
                                                                <span class="section-info-value" v-html="getTruncatedReason(eventItem.reason)"></span>
                                                                <v-btn 
                                                                    v-if="eventItem.reason && stripHtml(eventItem.reason).length > 150" 
                                                                    text 
                                                                    small 
                                                                    color="primary" 
                                                                    @click="toggleReason" 
                                                                    class="ml-2">
                                                                    {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                                                                </v-btn>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Observações</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.observation }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Documentos</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.docs.length
                                                                    }}
                                                                    arquivo(s)</span>
                                                            </p>
                                                           
                                                            <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                            <br>
                                                            <v-row
                                                                v-for="category in getEventItemsByCategory(eventItem)"
                                                                :key="category.id">
                                                                <v-col cols="12">
                                                                    <h3>{{ category.name }}</h3>
                                                                    <br>
                                                                    <v-row>
                                                                        <v-col v-for="doc in category.docs"
                                                                            :key="doc.id" cols="auto">
                                                                            <v-img @click="openDoc(doc.file_url)"
                                                                                class="rounded-xl"
                                                                                lazy-src="https://picsum.photos/id/11/10/6"
                                                                                :height="100" :width="100"
                                                                                :src="doc.file_url"></v-img>
                                                                            {{ doc.name }}
                                                                            <br>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                </v-row>
                               
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Revisão de Crédito</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                    
                                        <strong>Devedora: </strong> <span>{{ dataset.data.client ?
                                            dataset.data.client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                        }}</span>
                                        <br />
                                        <br>
                                        <span><strong>NEGÓCIO(S)</strong></span>
                                        <br />
                                    </v-col>

                                    <v-col class="d-flex justify-end align-center">
                                        <v-chip label class="mr-20" small
                                            :color="getColorByStatus(dataset.data.status, dataset.data.proposal_status)"
                                            style="color: white">
                                            {{
                                                dataset.data.status === 7 && dataset.data.proposal_status === 1
                                                  ? 'Contraproposta Aceita'
                                                  : dataset.data.status === 7 && dataset.data.proposal_status === 2
                                                  ? 'Contraproposta Rejeitada'
                                                  : $options.filters.enum(dataset.data.status, dataset.eventStatus, 'id', 'name')
                                            }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                               
                                <v-row>
                                    <v-col>
                                        <v-expansion-panels>
                                            <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.items"
                                                :key="eventIndex">
                                                <v-expansion-panel-header  @click.stop>

                                                    <div class="d-flex align-center">
                                                        <div>
                                                            <strong>ID: </strong>
                                                            <span class="ml-2 mr-2">#{{ eventItem.id }}</span> /
                                                            <strong>Origem: </strong>
                                                            <span class="ml-2 mr-2">{{ truncateText(eventItem.origin
                                                                ||
                                                                'N/A', 30) }}</span> /
                                                            <strong class="ml-2">Valor: </strong>
                                                            <span class="ml-2" v-if="eventItem.amount">
                                                                {{ eventItem.currency | enum(dataset.currencyTypes,
                                                                    'id',
                                                                    'currencyFormat') }}
                                                                {{ eventItem.amount | currency }}
                                                            </span>
                                                            <span v-else>N/A</span>
                                                        </div>

                                                        <v-spacer></v-spacer>

                                                        <v-chip label class="mr-10" small
                                                            :color="getColorByStatus(eventItem.status)"
                                                            style="color: white">
                                                            {{ eventItem.status | enum(dataset.eventStatus, 'id',
                                                                'name') }}
                                                        </v-chip>

                                                    </div>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row>
                                                        <v-col>
                                                            <p>
                                                                <span class="section-info-title">Devedora</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ dataset.data.client.name }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Origem</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.origin }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Moeda</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{
                                                                        eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'name'
                                                                        )
                                                                    }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Valor</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">{{
                                                                    eventItem.currency
                                                                    | enum(
                                                                        dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat'
                                                                    )
                                                                    }}
                                                                    {{
                                                                        eventItem.amount | currency
                                                                    }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Número pedido</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.request_number }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Motivo</span>
                                                                <br/>
                                                                <span class="section-info-value" v-html="getTruncatedReason(eventItem.reason)"></span>
                                                                <v-btn 
                                                                    v-if="eventItem.reason && stripHtml(eventItem.reason).length > 150" 
                                                                    text 
                                                                    small 
                                                                    color="primary" 
                                                                    @click="toggleReason" 
                                                                    class="ml-2">
                                                                    {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                                                                </v-btn>
                                                            </p>

                                                            <template>
                                                                <p>
                                                                    <span class="section-info-title"
                                                                        color="red">Contraditório</span>
                                                                    <br />

                                                                    <template v-if="eventItem.contradictory_status">
                                                                        <v-divider class="mb-3"></v-divider>
                                                                         <strong class="">Status: </strong>
                                                                        <v-chip x-small label class="mr-10"
                                                                            :color="getColorByStatus(eventItem.contradictory_status)">
                                                                            {{ eventItem.contradictory_status |
                                                                            enum(dataset.eventStatus, 'id',
                                                                                'name') }}
                                                                        </v-chip>
                                                                        <br />
                                                                        <br/>
                                                                        
                                                                        <strong>Valor indicado: </strong>

                                                                        <span v-if="eventItem.contradictory_amount"
                                                                            class="section-info-value text-uppercase">{{
                                                                                eventItem.currency
                                                                                | enum(
                                                                                    dataset.currencyTypes,
                                                                                    'id',
                                                                                    'currencyFormat'
                                                                                )
                                                                            }}
                                                                            {{
                                                                                eventItem.contradictory_amount | currency
                                                                            }}
                                                                        </span>
                                                                        <span v-else>N/A</span>

                                                                        <br />
                                                                            <br />
                                                                            <strong>Documentos: </strong>
                                                                           
                                                                            <template
                                                                                v-if="eventItem.contradictory_docs">
                                                                                <br />
                                                                                <span
                                                                                    v-for="(item, index) in resolveContradictoryDocs(eventItem)"
                                                                                    :key="index">
                                                                                    - <a :href="item">{{ item
                                                                                        }}</a><br />
                                                                                </span>
                                                                            </template>
                                                                            <span v-else>N/A</span>
                                                                            <br />
                                                                          
                                                                            <strong>Motivo: </strong>
                                                                            <br />
                                                                            <div v-if="eventItem.contradictory_reason"
                                                                                v-html="eventItem.contradictory_reason">
                                                                            </div>
                                                                            <span v-else>N/A</span>
                                                                            <br/>
                                                                        <v-divider class="mb-2"></v-divider>
                                                                    </template>

                                                                </p>
                                                            </template>

                                                            <p>
                                                                <span class="section-info-title">Observações</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.observation }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Documentos</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.docs.length
                                                                    }}
                                                                    arquivo(s)</span>
                                                            </p>
                                                            <!-- <v-row>
                                                                <v-col v-for="(docItem, docIndex ) in eventItem.docs" :key="docIndex">
                                                                    <v-img @click="openDoc(docItem.doc.file_url)"
                                                                        class="rounded-xl"
                                                                        lazy-src="https://picsum.photos/id/11/10/6"
                                                                        :height="100" :width="100"
                                                                        :src="docItem.doc.file_url"></v-img>
                                                                </v-col>
                                                            </v-row> -->
                                                            <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                            <br>
                                                            <v-row
                                                                v-for="category in getEventItemsByCategory(eventItem)"
                                                                :key="category.id">
                                                                <v-col cols="12">
                                                                    <h3>{{ category.name }}</h3>
                                                                    <br>
                                                                    <v-row>
                                                                        <v-col v-for="doc in category.docs"
                                                                            :key="doc.id" cols="auto">
                                                                            <v-img @click="openDoc(doc.file_url)"
                                                                                class="rounded-xl"
                                                                                lazy-src="https://picsum.photos/id/11/10/6"
                                                                                :height="100" :width="100"
                                                                                :src="doc.file_url"></v-img>
                                                                            {{ doc.name }}
                                                                            <br>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                </v-row>
                                <!-- <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="!dataset.loading && dataset.data.proposal_amount > 0 && dataset.data.proposal_at !== '0000-00-00 00:00:00'"
                            class="mt-4">
                            <v-col cols="12">
                                <v-card flat outlined class="pa-4" style="background-color: #f9f9f9;">
                                    <h3 class="mb-4">Contraproposta</h3>

                                    <v-card class="mb-4 pa-3" flat outlined style="border: 2px solid #78909C;">
                                        <v-row>
                                            <v-col cols="12" class="d-flex align-center mb-n5">
                                                <span>
                                                    <strong>Data de envio:</strong>
                                                    {{ dataset.data.proposal_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
                                                </span>
                                            </v-col>
                                            <v-col cols="12" class="mb-n5">
                                                <span><strong>Validade:</strong> {{ dataset.data.proposal_deadline_at |
                                                    defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                            </v-col>
                                            <v-col cols="12">
                                                <span><strong>Valor proposto:</strong> R$ {{
                                                    dataset.data.proposal_amount | currency }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="dataset.data.proposal_status !== 0 && dataset.data.proposal_creditor_at !== '0000-00-00 00:00:00'"
                                        class="mb-4 pa-3" flat outlined :style="`border: 2px solid ${
                                    dataset.data.proposal_status === 1 ? '#4CAF50' : 
                                    dataset.data.proposal_status === 2 ? '#F44336' : '#9E9E9E'
                                    };`">
                                        <h4 class="mb-2">Resposta credor:</h4>
                                        <v-row>
                                            <v-col cols="12" class="mt-2 d-flex align-center mb-n5">
                                                <span><strong>Data:</strong> {{ dataset.data.proposal_creditor_at |
                                                    defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                            </v-col>

                                            <v-col cols="12" class="d-flex align-center">
                                                <span>
                                                    <strong>Status:</strong>
                                                    <v-chip small class="ml-2 white--text"
                                                        :color="dataset.data.proposal_status === 1 ? 'green' : dataset.data.proposal_status === 2 ? 'red' : 'grey'">
                                                        {{
                                                        dataset.data.proposal_status === 1 ? 'Aprovado' :
                                                        dataset.data.proposal_status === 2 ? 'Rejeitado' : 'Indefinido'
                                                        }}
                                                    </v-chip>
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-alert v-else type="info" color="warning" outlined icon="mdi-clock-outline">
                                        <template v-slot:prepend>
                                            <v-icon color="grey darken-4">mdi-clock-outline</v-icon>
                                        </template>
                                        <span class="text--primary ml-3">O credor ainda não respondeu à
                                            contraproposta.</span>
                                    </v-alert>
                                </v-card>
                            </v-col>
                        </v-row>

                    </v-card-text>
                    <v-card-actions class="pa-4" >
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                              <v-btn
                                v-on="on"
                                id="btnProposal"
                                type="button"
                                color="primary"
                                elevation="0"
                                :disabled="dataset.data.proposal_status === 1"
                                class="btn-dropdown"
                                @click="openProposalModal()"
                              >
                                <v-icon left size="24">mdi-account-arrow-up-outline</v-icon>
                                CONTRAPROPOSTA
                              </v-btn>
                            </template>
                            <span>Enviar contraproposta ao credor</span>
                          </v-tooltip>
                    </v-card-actions>

                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <template >
                    <v-card class="card-form-outlined" color="gray">
                        <v-card-title class="card-group-title">
                            <div class="title-container">
                                <div class="title-block">
                                    <span id="title" class="table-card-title">Motivo</span>
                                </div>
                            </div>
                        </v-card-title>
                  
                        <!-- <v-divider class="mb-3" v-if="dataset.data && dataset.data.reason"></v-divider> -->

                        <v-card-text v-if="dataset.data && dataset.data.reason">
                            <p><span v-html="dataset.data.reason"></span></p>
                            <br>  
                        </v-card-text>
                        <v-alert v-else type="info" outlined>
                             Nenhuma informação disponível.
                        </v-alert>
                    </v-card>  
                </template>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

        <!-- Modal contraproposta-->
        <v-dialog v-model="proposalModal" max-width="600px">
            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    CONTRAPROPOSTA
                </v-card-title>
                <br>
                <v-card-text>
                    <p>
                        Informe o valor da contraproposta, anexe o documento e adicione uma observação, se necessário.
                    </p>
                    <br>
                    <v-form ref="proposalForm" @submit.prevent="saveProposal">
                        <v-row class="mb-n5">
                            <v-col cols="12" sm="12"> 
                                <v-currency-field label="Valor" dense
                                    v-model="proposal.proposal_amount" :allowNegative=false
                                    hide-details="auto" outlined>
                                </v-currency-field>
                            </v-col>
                            <v-col cols="12">
                                <v-file-input
                                    :show-size="true" counter hint="O arquivo não pode ser superior a 15MB"
                                    dense prepend-icon="" outlined placeholder="Selecionar documento"
                                    :clearable="true" hide-details="auto" label="Adicionar documento"
                                    @change="onProposalFileSelected($event)" truncate-length="50"
                                    accept="image/png, image/jpeg, application/pdf, .csv, application/vnd.ms-excel">
                                </v-file-input>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                              <v-textarea label="Observação" v-model="proposal.proposal_reason" outlined
                                dense clearable auto-grow rows="1" counter maxlength="255"
                              ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn text color="grey" @click="proposalModal = false">Cancelar</v-btn>
                            <v-btn color="primary"
                                type="submit" :loading="loadingProposal">Salvar</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"

import userTypes from "@/common/data/user-types.data"
import currencyTypes from "@/common/data/currency-types.data"
import documentTypes from "@/common/data/document-types.data"
import eventStatus from "@/common/data/event-status.data"

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Table, TableCell, TableHeader,
    TableRow, TodoList, TodoItem
} from 'tiptap-vuetify'



export default {
    name: "UserDetails",

    components: { 'tiptap-vuetify': TiptapVuetify },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        isReasonExpanded: false,
        proposalModal: false,
        loadingProposal: false,
        proposal:{
            proposal_amount: null,
            proposal_reason: null,
            proposal_doc: null,
        },
        dataset: {
            userTypes: userTypes,
            currencyTypes: currencyTypes,
            documentTypes: documentTypes,
            breadcrumbItems: [],
            states: states,
            eventStatus: eventStatus,
            data: {
                contradictory_reason: "",
                items: []
            },
            events: [],
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        selectedDoc: null,
        dialogViewDoc: false,
        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [1, 2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            [Table, {
                options: {
                    resizable: true
                }
            }],
            TableCell,
            TableHeader,
            TableRow,
        ],
    }),

    created() {
        this.loadData();
    },

    methods: {
        goBack() {
            this.$router.replace("/revisao-credito");
        },

        onFileSelected(file) {
            this.dataset.data.contradictory_reason_file = file
        },

        onProposalFileSelected(file) {
            this.proposal.proposal_doc = file
        },

        openDoc(doc) {
            window.open(doc, '_blank');
        },

        truncateText(text, maxLength) {

            if (!text) return 'N/A';

            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

        },

        async loadData() {
            await this.load();
            this.setPage();
            this.listBreadCrumbItems();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = 'Detalhes da revisão de crédito';
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Revisão de Crédito",
                disabled: false,
                to: "/revisao-credito",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: 'Detalhes da revisão de crédito',
                disabled: true,
                exact: true,
            });
        },

        async updateContradictory() {

            if (!this.dataset.data.contradictory_reason) {
                this.$dialog.notify.error("Contraditório é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar a revisão de crédito?`,
                title: `Atualizar revisão de crédito`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const formData = new FormData();

            formData.append("contradictory_reason", this.dataset.data.contradictory_reason)

            if (this.dataset.data.contradictory_reason_file) {
                formData.append('reason', this.dataset.data.contradictory_reason_file);
            }

            try {
                const response = await axios.patch(`/api/admin/user-objection-events/contradictory/${this.$route.params.id}`, formData);

                this.$dialog.notify.info(`Revisão de crédito atualizada com sucesso!`, { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async load() {

            try {
                const result = await axios.get(`/api/admin/user-objection-events/find/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.data.smallReason = data.small_reason || ""
                this.dataset.data.reason = data.reason || ""

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        getEventItemsByCategory(eventItem) {
            const categories = {};

            eventItem.docs.forEach(docItem => {
                const category_id = docItem.doc.type;

                if (!categories[category_id]) {
                    categories[category_id] = {
                        id: category_id,
                        name: this.getCategoryName(category_id),
                        docs: []
                    };
                }

                categories[category_id].docs.push({
                    id: docItem.id,
                    name: docItem.doc.name,
                    file_url: docItem.doc.file_url
                });
            });

            return Object.values(categories);
        },

        getCategoryName(category_id) {
            return this.dataset.documentTypes.find(category => category.id === category_id).name;
        },

        toggleReason() {
            this.isReasonExpanded = !this.isReasonExpanded;
        },

        stripHtml(html) {
            if (!html) return '';
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || '';
        },

        getTruncatedReason(reason) {
            const rawText = this.stripHtml(reason);
            if (!this.isReasonExpanded && rawText.length > 150) {
                return rawText.substring(0, 150) + '...';
            }
            return rawText;
        },

        getColorByStatus(status, proposal_status = null) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                case 3:
                    return '#80CBC4';
                case 4:
                    return '#7E55AB';
                case 5:
                    return '#29B6F6';
                case 6:
                    return '#9E9D24';
                case 7:
                    if (proposal_status === 1) {
                        return '#00695C';
                    }
                    if (proposal_status === 2) {
                        return '#BF360C'; 
                    }
                return '#00695C';
                default:
                    return 'grey';
            }
        },


        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        openProposalModal() {

            // if (this.dataset.data.status != 0 || this.dataset.data.enable_contradictory != 2){

            //     this.$dialog.notify.error("O prazo para envio de contraproposta já expirou!", {
            //         position: "top-right",
            //         timeout: 3000
            //     });

            //     return;
            // } 
    
            this.proposalModal = true;
        
        },

        async saveProposal() {
            
            if (!this.proposal.proposal_amount) {
                this.$dialog.notify.error(
                    "Por favor entre com o valor da proposta!",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            if (this.dataset.data.status === 2){
                this.$dialog.notify.error(
                    "O status atual do pedido não permite enviar contraproposta ao credor!",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar a contraproposta?`,
                title: `Enviar contraproposta`,
                actions: {
                    false: 'Cancelar',
                    true: 'Enviar'
                }
            })

            if (!proceedAction) {
                return;
            }

            this.loadingProposal = true;

            try {

                let payload = this.buildPayload();

                const response = await axios.post(`/api/admin/user-objection-events/event-proposal`, payload,
                    {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                );

                this.$dialog.notify.info("Contraproposta enviada com sucesso!", { position: "top-right", timeout: 2000 });

                await this.load();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.proposal.proposal_amount = null;
                this.proposal.proposal_doc = null;
                this.proposal.proposal_reason = null;
                this.proposal.proposal_doc = null;
                this.loadingProposal = false;
                this.proposalModal = false;
            }
        },

        buildPayload() {
            
            const formData = new FormData();

            if (this.dataset.data.user_id)
            formData.append('user_id', this.dataset.data.user_id);

            if (this.dataset.data.id)
            formData.append('user_objection_event_id', this.dataset.data.id);

            if (this.proposal.proposal_amount)
            formData.append('proposal_amount', this.proposal.proposal_amount);

            if (this.proposal.proposal_reason)
            formData.append('proposal_reason', this.proposal.proposal_reason);

            if (this.proposal.proposal_doc) {
                formData.append('proposal_doc', this.proposal.proposal_doc);
            }
            
            return formData;

        },

        resolveContradictoryDocs(eventItem) {
            const raw = eventItem ? eventItem.contradictory_docs : (this.dataset.data && this.dataset.data.contradictory_docs);

            if (!raw) return [];

            try {
                const docs = typeof raw === 'string' ? JSON.parse(raw) : raw;
                return Array.isArray(docs) ? docs : [];
            } catch (e) {
                return [];
            }
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

</style>